import text from './text.json'
import ListItem from './ListItem'
import classNames from 'classnames'
import './index.scss'
import {groupDataByProperty} from '../../../../utils/object'

const ListView = ({
    data,
    isDarkMode,
    showEditModal
}) => {
    const groupedData = groupDataByProperty(data, 'type')

    return (
        <div
            className={classNames('ruleset-grid', {
                dark: isDarkMode
            })}
        >
            <div
                className={classNames('ruleset-list', {
                    dark: isDarkMode
                })}
            >
                {Object.entries(groupedData).map(
                    ([type, data]) => {
                        return (
                            <div
                                key={type}
                                className={classNames('ruleset-group', {
                                    dark: isDarkMode
                                })}
                            >
                                <div className="ruleset-group-header">
                                    <div className="ruleset-group-title">
                                        <h3 className="ruleset-metric-title">
                                            {data[0].type}
                                        </h3>
                                    </div>
                                    <div className='ruleset-group-header-list'>
                                        <div className="header-row">
                                            <span className="title">{text.urgency}</span>
                                        </div>
                                        <div className="header-row">
                                            <span className="title">{text.status}</span>
                                        </div>
                                        <div className="header-row">
                                            <span className="title">{text.updated_at}</span>
                                        </div>
                                        <div className="header-row actions w-0">
                                        </div>
                                    </div>
                                </div>
                                {data.map((item, index) => (
                                    <ListItem
                                        key={index}
                                        item={item}
                                        isDarkMode={isDarkMode}
                                        showEditModal={showEditModal}
                                    />
                                ))}
                            </div>
                        )
                    }
                )}
            </div>
        </div>
    )
}

export default ListView
